import React from 'react';
import classnames from 'classnames';
import styles from './inline-loader.css';

interface InlineLoaderProps {
  /** Adds additional classes to the component. */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * InlineLoader Component
 *
 * @param {InlineLoaderProps} param
 *
 * @returns JSX.ELEMENT
 */
export const InlineLoader = ({ className, 'data-testid': dataTestid }: InlineLoaderProps) => {
  const loaderClasses = classnames(styles.loader, className);
  return (
    <div className={loaderClasses} data-testid={dataTestid}>
      <div className={`${styles.child} ${styles.bounce1}`} />
      <div className={`${styles.child} ${styles.bounce2}`} />
      <div className={`${styles.child}`} />
    </div>
  );
};

export default InlineLoader;
